"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _trtcJsSdk = _interopRequireDefault(require("trtc-js-sdk"));
var _utils = require("../utils/utils.js");
/*
 * @Description: 音视频通话集成
 * @Date: 2022-03-14 17:15:23
 * @LastEditTime: 2022-03-23 17:47:14
 */
var _default = {
  data: function data() {
    return {
      client: null,
      localStream: null,
      remoteStreamList: [],
      isJoining: false,
      isJoined: false,
      isPublishing: false,
      isPublished: false,
      isMutedVideo: false,
      isMutedAudio: false,
      isPlayingLocalStream: false
    };
  },
  methods: {
    // 初始化客户端
    initClient: function () {
      var _initClient = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.client = _trtcJsSdk.default.createClient({
                mode: 'rtc',
                sdkAppId: this.sdkAppId,
                userId: this.userId,
                userSig: this.userSig
              });
              this.addSuccessLog("Client [".concat(this.userId, "] created."));
              this.handleClientEvents();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initClient() {
        return _initClient.apply(this, arguments);
      }
      return initClient;
    }(),
    initLocalStream: function () {
      var _initLocalStream = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.localStream = _trtcJsSdk.default.createStream({
                audio: true,
                video: true,
                userId: this.userId,
                cameraId: this.cameraId,
                microphoneId: this.microphoneId
              });
              _context2.prev = 1;
              _context2.next = 4;
              return this.localStream.initialize();
            case 4:
              this.addSuccessLog("LocalStream [".concat(this.userId, "] initialized."));
              _context2.next = 12;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);
              this.localStream = null;
              this.addFailedLog("LocalStream failed to initialize. Error: ".concat(_context2.t0.message, "."));
              throw _context2.t0;
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 7]]);
      }));
      function initLocalStream() {
        return _initLocalStream.apply(this, arguments);
      }
      return initLocalStream;
    }(),
    playLocalStream: function playLocalStream() {
      var _this = this;
      this.localStream.play('localStream').then(function () {
        _this.isPlayingLocalStream = true;
        _this.addSuccessLog("LocalStream [".concat(_this.userId, "] playing."));
      }).catch(function (error) {
        _this.addFailedLog("LocalStream [".concat(_this.userId, "] failed to play. Error: ").concat(error.message));
      });
    },
    destroyLocalStream: function destroyLocalStream() {
      this.localStream && this.localStream.stop();
      this.localStream && this.localStream.close();
      this.localStream = null;
      this.isPlayingLocalStream = false;
    },
    playRemoteStream: function playRemoteStream(remoteStream, element) {
      if (remoteStream.getType() === 'main' && remoteStream.getUserId().indexOf('share') >= 0) {
        remoteStream.play(element, {
          objectFit: 'contain'
        }).catch();
      } else {
        remoteStream.play(element).catch();
      }
    },
    resumeStream: function resumeStream(stream) {
      stream.resume();
    },
    join: function () {
      var _join = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.isJoining || this.isJoined)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              this.isJoining = true;
              _context3.t0 = !this.client;
              if (!_context3.t0) {
                _context3.next = 7;
                break;
              }
              _context3.next = 7;
              return this.initClient();
            case 7:
              _context3.prev = 7;
              _context3.next = 10;
              return this.client.join({
                roomId: this.roomId
              });
            case 10:
              this.isJoining = false;
              this.isJoined = true;
              this.addSuccessLog("Join room [".concat(this.roomId, "] success."));
              this.reportSuccessEvent('joinRoom');
              this.startGetAudioLevel();
              _context3.next = 24;
              break;
            case 17:
              _context3.prev = 17;
              _context3.t1 = _context3["catch"](7);
              this.isJoining = false;
              console.error('join room failed', _context3.t1);
              this.addFailedLog("Join room ".concat(this.roomId, " failed, please check your params. Error: ").concat(_context3.t1.message));
              this.reportFailedEvent('joinRoom', _context3.t1);
              throw _context3.t1;
            case 24:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[7, 17]]);
      }));
      function join() {
        return _join.apply(this, arguments);
      }
      return join;
    }(),
    publish: function () {
      var _publish = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!this.isJoined || this.isPublishing || this.isPublished)) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              this.isPublishing = true;
              _context4.prev = 3;
              _context4.next = 6;
              return this.client.publish(this.localStream);
            case 6:
              this.isPublishing = false;
              this.isPublished = true;
              this.addSuccessLog('LocalStream is published successfully.');
              this.reportSuccessEvent('publish');
              _context4.next = 19;
              break;
            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](3);
              this.isPublishing = false;
              console.error('publish localStream failed', _context4.t0);
              this.addFailedLog("LocalStream is failed to publish. Error: ".concat(_context4.t0.message));
              this.reportFailedEvent('publish');
              throw _context4.t0;
            case 19:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[3, 12]]);
      }));
      function publish() {
        return _publish.apply(this, arguments);
      }
      return publish;
    }(),
    unPublish: function () {
      var _unPublish = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(!this.isPublished || this.isUnPublishing)) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              this.isUnPublishing = true;
              _context5.prev = 3;
              _context5.next = 6;
              return this.client.unpublish(this.localStream);
            case 6:
              this.isUnPublishing = false;
              this.isPublished = false;
              this.addSuccessLog('localStream unpublish successfully');
              this.reportSuccessEvent('unpublish');
              _context5.next = 19;
              break;
            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](3);
              this.isUnPublishing = false;
              console.error('unpublish localStream failed', _context5.t0);
              this.addFailedLog("LocalStream is failed to unpublish. Error: ".concat(_context5.t0.message));
              this.reportFailedEvent('unpublish', _context5.t0);
              throw _context5.t0;
            case 19:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[3, 12]]);
      }));
      function unPublish() {
        return _unPublish.apply(this, arguments);
      }
      return unPublish;
    }(),
    subscribe: function () {
      var _subscribe = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6(remoteStream) {
        var config,
          _args6 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              config = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {
                audio: true,
                video: true
              };
              _context6.prev = 1;
              _context6.next = 4;
              return this.client.subscribe(remoteStream, {
                audio: (0, _utils.isUndefined)(config.audio) ? true : config.audio,
                video: (0, _utils.isUndefined)(config.video) ? true : config.video
              });
            case 4:
              this.addSuccessLog("Subscribe [".concat(remoteStream.getUserId(), "] success"));
              this.reportSuccessEvent('subscribe');
              _context6.next = 13;
              break;
            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](1);
              console.error("subscribe ".concat(remoteStream.getUserId(), " with audio: ").concat(config.audio, " video: ").concat(config.video, " error"), _context6.t0);
              this.addFailedLog("Subscribe ".concat(remoteStream.getUserId(), " failed!"));
              this.reportFailedEvent('subscribe', _context6.t0);
            case 13:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[1, 8]]);
      }));
      function subscribe(_x) {
        return _subscribe.apply(this, arguments);
      }
      return subscribe;
    }(),
    unSubscribe: function () {
      var _unSubscribe = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee7(remoteStream) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return this.client.unsubscribe(remoteStream);
            case 3:
              this.addSuccessLog("unsubscribe [".concat(remoteStream.getUserId(), "] success"));
              this.reportSuccessEvent('unsubscribe');
              _context7.next = 12;
              break;
            case 7:
              _context7.prev = 7;
              _context7.t0 = _context7["catch"](0);
              console.error("unsubscribe ".concat(remoteStream.getUserId(), " error"), _context7.t0);
              this.addFailedLog("unsubscribe ".concat(remoteStream.getUserId(), " failed!"));
              this.reportFailedEvent('unsubscribe', _context7.t0);
            case 12:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 7]]);
      }));
      function unSubscribe(_x2) {
        return _unSubscribe.apply(this, arguments);
      }
      return unSubscribe;
    }(),
    leave: function () {
      var _leave = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee8() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(!this.isJoined || this.isLeaving)) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return");
            case 2:
              this.isLeaving = true;
              this.stopGetAudioLevel();
              _context8.t0 = this.isPublished;
              if (!_context8.t0) {
                _context8.next = 8;
                break;
              }
              _context8.next = 8;
              return this.unPublish();
            case 8:
              this.localStream && this.destroyLocalStream();
              _context8.prev = 9;
              _context8.next = 12;
              return this.client.leave();
            case 12:
              this.isLeaving = false;
              this.isJoined = false;
              this.addSuccessLog('Leave room success');
              this.reportSuccessEvent('leaveRoom');
              _context8.next = 25;
              break;
            case 18:
              _context8.prev = 18;
              _context8.t1 = _context8["catch"](9);
              this.isLeaving = false;
              console.error('leave room error', _context8.t1);
              this.addFailedLog("Leave room failed. Error: ".concat(_context8.t1.message));
              this.reportFailedEvent('leaveRoom', _context8.t1);
              throw _context8.t1;
            case 25:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[9, 18]]);
      }));
      function leave() {
        return _leave.apply(this, arguments);
      }
      return leave;
    }(),
    muteVideo: function muteVideo() {
      if (this.localStream) {
        this.localStream.muteVideo();
        this.isMutedVideo = true;
        this.addSuccessLog('LocalStream muted video');
      }
    },
    muteAudio: function muteAudio() {
      if (this.localStream) {
        this.localStream.muteAudio();
        this.isMutedAudio = true;
        this.addSuccessLog('LocalStream muted audio');
      }
    },
    unmuteVideo: function unmuteVideo() {
      if (this.localStream) {
        this.localStream.unmuteVideo();
        this.isMutedVideo = false;
        this.addSuccessLog('LocalStream unmuted video');
      }
    },
    unmuteAudio: function unmuteAudio() {
      if (this.localStream) {
        this.localStream.unmuteAudio();
        this.isMutedAudio = false;
        this.addSuccessLog('LocalStream unmuted audio');
      }
    },
    switchDevice: function switchDevice(type, deviceId) {
      try {
        if (this.localStream) {
          this.localStream.switchDevice(type, deviceId);
          this.addSuccessLog("Switch ".concat(type, " device success"));
        }
      } catch (error) {
        console.error('switchDevice failed', error);
        this.addFailedLog("Switch ".concat(type, " device failed"));
      }
    },
    startGetAudioLevel: function startGetAudioLevel() {
      // 文档：https://web.sdk.qcloud.com/trtc/webrtc/doc/zh-cn/module-ClientEvent.html#.AUDIO_VOLUME
      this.client.on('audio-volume', function (event) {
        event.result.forEach(function (_ref) {
          var userId = _ref.userId,
            audioVolume = _ref.audioVolume;
          if (audioVolume > 2) {
            console.log("user: ".concat(userId, " is speaking, audioVolume: ").concat(audioVolume));
          }
        });
      });
      this.client.enableAudioVolumeEvaluation(200);
    },
    stopGetAudioLevel: function stopGetAudioLevel() {
      this.client && this.client.enableAudioVolumeEvaluation(-1);
    },
    handleClientEvents: function handleClientEvents() {
      var _this2 = this;
      this.client.on('error', function (error) {
        console.error(error);
        alert(error);
      });
      this.client.on('client-banned', /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee9(error) {
          return (0, _regeneratorRuntime2.default)().wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                console.error("client has been banned for ".concat(error));
                _this2.isPublished = false;
                _this2.localStream = null;
                _context9.next = 5;
                return _this2.leave();
              case 5:
                alert(error);
              case 6:
              case "end":
                return _context9.stop();
            }
          }, _callee9);
        }));
        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }());
      // fired when a remote peer is joining the room
      this.client.on('peer-join', function (event) {
        var userId = event.userId;
        console.log("peer-join ".concat(userId), event);
      });
      // fired when a remote peer is leaving the room
      this.client.on('peer-leave', function (event) {
        var userId = event.userId;
        console.log("peer-leave ".concat(userId), event);
      });

      // fired when a remote stream is added
      this.client.on('stream-added', function (event) {
        var remoteStream = event.stream;
        var remoteUserId = remoteStream.getUserId();
        if (remoteUserId === "share_".concat(_this2.userId)) {
          // don't need screen shared by us
          _this2.unSubscribe(remoteStream);
        } else {
          console.log("remote stream added: [".concat(remoteUserId, "] type: ").concat(remoteStream.getType()));
          // subscribe to this remote stream
          _this2.subscribe(remoteStream);
          _this2.addSuccessLog("RemoteStream added: [".concat(remoteUserId, "]"));
        }
      });
      // fired when a remote stream has been subscribed
      this.client.on('stream-subscribed', function (event) {
        var remoteStream = event.stream;
        var remoteUserId = remoteStream.getUserId();
        console.log('stream-subscribed userId: ', remoteUserId);
        _this2.addSuccessLog("RemoteStream subscribed: [".concat(remoteUserId, "]."));
        _this2.remoteStreamList.push(remoteStream);
        _this2.$nextTick(function () {
          _this2.playRemoteStream(remoteStream, remoteUserId);
        });
      });
      // fired when the remote stream is removed, e.g. the remote user called Client.unpublish()
      this.client.on('stream-removed', function (event) {
        var remoteStream = event.stream;
        remoteStream.stop();
        var index = _this2.remoteStreamList.indexOf(remoteStream);
        if (index >= 0) {
          _this2.remoteStreamList.splice(index, 1);
        }
        console.log("stream-removed userId: ".concat(remoteStream.getUserId(), " type: ").concat(remoteStream.getType()));
      });
      this.client.on('stream-updated', function (event) {
        var remoteStream = event.stream;
        console.log("type: ".concat(remoteStream.getType(), " stream-updated hasAudio: ").concat(remoteStream.hasAudio(), " hasVideo: ").concat(remoteStream.hasVideo()));
        _this2.addSuccessLog("RemoteStream updated: [".concat(remoteStream.getUserId(), "] audio:").concat(remoteStream.hasAudio(), " video:").concat(remoteStream.hasVideo()));
      });
      this.client.on('mute-audio', function (event) {
        var userId = event.userId;
        console.log("".concat(userId, " mute audio"));
        _this2.addSuccessLog("[".concat(event.userId, "] mute audio"));
      });
      this.client.on('unmute-audio', function (event) {
        var userId = event.userId;
        console.log("".concat(userId, " unmute audio"));
        _this2.addSuccessLog("[".concat(event.userId, "] unmute audio"));
      });
      this.client.on('mute-video', function (event) {
        var userId = event.userId;
        console.log("".concat(userId, " mute video"));
        _this2.addSuccessLog("[".concat(event.userId, "] mute video"));
      });
      this.client.on('unmute-video', function (event) {
        var userId = event.userId;
        console.log("".concat(userId, " unmute video"));
        _this2.addSuccessLog("[".concat(event.userId, "] unmute video"));
      });
      this.client.on('connection-state-changed', function (event) {
        console.log("RtcClient state changed to ".concat(event.state, " from ").concat(event.prevState));
      });
      this.client.on('network-quality', function (event) {
        var uplinkNetworkQuality = event.uplinkNetworkQuality,
          downlinkNetworkQuality = event.downlinkNetworkQuality;
        console.log("network-quality uplinkNetworkQuality: ".concat(uplinkNetworkQuality, ", downlinkNetworkQuality: ").concat(downlinkNetworkQuality));
      });
    }
  }
};
exports.default = _default;